import { checkPermission } from "./common";
import { ROLE_ACTION_METHODS, ROLE_ACTIONS } from "@/config/constants";

export const objectPer = (objectKey) => {
  const result = {};
  const methodKeys = Object.keys(ROLE_ACTION_METHODS);
  methodKeys.forEach((key) => {
    result[key] = checkPermission(objectKey, ROLE_ACTION_METHODS[key])
  })
  return result
}

export const categoryPer = () => {
  return objectPer(ROLE_ACTIONS.CATEGORY)
}

export const filePer = () => {
  return objectPer(ROLE_ACTIONS.FILE)
}

export const tagPer = () => {
  return objectPer(ROLE_ACTIONS.TAG)
}

export const createAccountPer = () => {
  return objectPer(ROLE_ACTIONS.CREATE_ACCOUNT)
}

export const orgSettingPer = () => {
  return objectPer(ROLE_ACTIONS.ORGANIZATION_SETTING)
}

export const rolePer = () => {
  return objectPer(ROLE_ACTIONS.MANAGEMENT_ROLE)
}

export const roleUserPer = () => {
  return objectPer(ROLE_ACTIONS.MANAGEMENT_ROLE_USER)
}

export const accountPer = () => {
  return objectPer(ROLE_ACTIONS.ACCOUNT_MANAGEMENT)
}
